exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section{width:950px;max-width:calc(100% - 40px);margin:110px auto}.section h2{text-transform:uppercase;text-align:center}.section.centered{text-align:center}.section b{margin:0;padding:0;opacity:0.7}.section p{margin-top:0;padding:0}.section button{border-radius:100px;background-color:#015351;color:white;padding:0 40px}.section .primary button{background-color:#015351;color:white}.section .bright button{background-color:#dcedff;color:black}.section.slim{margin:40px auto}.section img{width:100%}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/Section/Section.scss
// module id = 309
// module chunks = 0